import React from 'react'
import { SearchBox, SelectBox } from 'components'
import { AuthContainer } from 'containers'
import { useGetCompany } from 'hooks'
import { GetCompanyResponse } from 'types/getCompany'

type SelectSupplierBarProps = {
  variant: 'dropdown' | 'select'
  value: string
  onChange(value: string, text: string, supplierDetails?: GetCompanyResponse[number]): void
}

export const SelectSupplierBar = (props: SelectSupplierBarProps) => {
  const { variant, value, onChange } = props
  const { selectedSupplier, user } = AuthContainer.useContainer()
  const [searchValue, setSearchValue] = React.useState('')

  const { getCompanyStatus, getCompanyData } = useGetCompany({
    companyName: searchValue,
    companyType: 'Supplier',
  })

  const handleSelect = (value: string, text: string, supplierDetails?: GetCompanyResponse[number]) => {
    onChange(value, text, supplierDetails)
  }

  const getRelatedSupplierOptions = () => {
    const relatedSupplierOptions = (user?.relatedSuppliers || []).map((item) => ({
      text: item.supplierName,
      value: item.oracleId,
      supplierDetails: item,
    }))

    if (user?.supplierDetails?.supplierName && !isNaN(parseInt(user?.supplierDetails?.oracleId ?? '')))
      relatedSupplierOptions.unshift({
        text: user.supplierDetails.supplierName,
        value: user.supplierDetails.oracleId,
        supplierDetails: user.supplierDetails,
      })

    const filteredSupplierOptions = relatedSupplierOptions.filter(
      (item, index, self) => index === self.findIndex((t) => t.text === item.text && t.value === item.value)
    )

    return filteredSupplierOptions
  }

  return (
    <div className="flex flex-wrap items-end gap-4">
      {variant === 'select' && (
        <div className="flex flex-col w-full sm:w-64">
          <SearchBox
            label="Supplier *"
            placeholder="Enter supplier name"
            id="supplier"
            isLoading={getCompanyStatus === 'loading'}
            value={selectedSupplier?.name ?? ''}
            searchValue={searchValue}
            options={(getCompanyData || []).map((item) => ({
              text: item.companyName,
              value: item.oracleId ?? '',
            }))}
            onChange={(value, text) => {
              handleSelect(
                value,
                text,
                getCompanyData?.find((company) => company.companyName === text)
              )
            }}
            onChangeSearch={setSearchValue}
          />
        </div>
      )}
      {variant === 'dropdown' && (
        <div className="flex flex-col w-full sm:w-64">
          <SelectBox
            label="Supplier *"
            id="supplier"
            placeholder="Select supplier"
            enableSearch={getRelatedSupplierOptions().length > 8}
            value={value}
            options={getRelatedSupplierOptions()}
            onChange={(value: string, text: string) => {
              const supDet = getRelatedSupplierOptions().find((item) => item.text === text)?.supplierDetails
              const supplierDetails: GetCompanyResponse[number] = {
                companyName: supDet?.supplierName ?? '',
                companyType: 'Supplier',
                roles: [],
                supplierId: supDet?.supplierId,
                oracleId: supDet?.oracleId,
                relatedGroup: supDet?.relatedGroup,
              }
              onChange(value, text, supplierDetails)
            }}
          />
        </div>
      )}
    </div>
  )
}
